import { render, staticRenderFns } from "./News261022.vue?vue&type=template&id=de8ae6da&scoped=true&"
import script from "./News261022.vue?vue&type=script&lang=js&"
export * from "./News261022.vue?vue&type=script&lang=js&"
import style0 from "./News261022.vue?vue&type=style&index=0&id=de8ae6da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8ae6da",
  null
  
)

export default component.exports